import { defineMessages } from 'react-intl';

export const commonMessages = defineMessages({
  closeLabel: { id: 'commonMessages.close', defaultMessage: 'Close' },
});
